import { MapPin } from "lucide-react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";

const LOCATIONS = [
  { city: "Philadelphia, PA", note: "[Placeholder address]" },
  { city: "Charlotte, NC", note: "[Placeholder address]" },
];

const Locations = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.locations");
  return (
  <div>
    <PageHeader eyebrow={h.eyebrow} title={h.title} />
    <div className="max-w-2xl mx-auto px-5 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
      {LOCATIONS.map((l) => (
        <div key={l.city} className="dw-card text-center">
          <MapPin className="mx-auto" size={26} strokeWidth={1.5} style={{ color: "var(--dw-accent)" }} />
          <h3 className="pt-3">{l.city}</h3>
          <p className="dw-mini pt-1 text-sm">{l.note}</p>
        </div>
      ))}
    </div>
  </div>
  );
};

export default Locations;
